import { useMutation } from "react-query";
import { loggedInApiCall } from "src/api/axiosClient/userApi";
import { useSnackbar } from "src/utils/useSnackbar";
import { useTranslation } from "react-i18next";

export const useDeleteComment = () => {
    const snackbar = useSnackbar();
    const { t } = useTranslation();

    return useMutation({
        mutationFn: async (commentId: string) => {
            await loggedInApiCall.delete(`/api/diagnostic/ssq-post_comment/${commentId}`);
            return true;
        },
        onError: (error) => {
            snackbar.setSnackbarProps({
                type: "error",
                message: t("property.note.deletion_error"),
            });
        },
    });
};
